import { render, staticRenderFns } from "./TreatmentRecommendationBasis.vue?vue&type=template&id=59f6fc2f&scoped=true"
import script from "./TreatmentRecommendationBasis.vue?vue&type=script&lang=js"
export * from "./TreatmentRecommendationBasis.vue?vue&type=script&lang=js"
import style0 from "./TreatmentRecommendationBasis.vue?vue&type=style&index=0&id=59f6fc2f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f6fc2f",
  null
  
)

export default component.exports